export interface ExtractedMentions {
	userIds: string[];
	hashtagIds: string[];
}

/**
 * Pulls the distinct @user ids and #hashtag uuids out of the mention spans
 * TipTap serialises into the editor HTML. Works on a single body string;
 * callers merge across multiple blocks.
 */
export const extractMentions = (html: string): ExtractedMentions => {
	const userIds = new Set<string>();
	const hashtagIds = new Set<string>();
	if (!html) return { userIds: [], hashtagIds: [] };

	const doc = new DOMParser().parseFromString(html, "text/html");
	doc.querySelectorAll('span[data-type="mention"]').forEach((el) => {
		const id = el.getAttribute("data-id");
		if (!id) return;
		if (el.getAttribute("data-mention-type") === "hashtag") {
			hashtagIds.add(id);
		} else {
			userIds.add(id);
		}
	});
	return { userIds: [...userIds], hashtagIds: [...hashtagIds] };
};

export const mergeMentions = (
	parts: ExtractedMentions[]
): ExtractedMentions => ({
	userIds: [...new Set(parts.flatMap((p) => p.userIds))],
	hashtagIds: [...new Set(parts.flatMap((p) => p.hashtagIds))]
});
